"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _helpers = require("@qwkin/helpers");
var _core = require("@material-ui/core");
var _theme = require("../utils/theme");
var _excluded = ["controlledOpened", "theme", "onClick", "onClose", "anchorOrigin", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var withContextMenu = function withContextMenu(Component) {
  var ContextMenu = function ContextMenu(_ref) {
    var _ref$controlledOpened = _ref.controlledOpened,
      controlledOpened = _ref$controlledOpened === void 0 ? null : _ref$controlledOpened,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? _helpers.identity : _ref$onClick,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? _helpers.identity : _ref$onClose,
      anchorOrigin = _ref.anchorOrigin,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];
    var open = controlledOpened !== null ? controlledOpened && Boolean(anchorEl) : Boolean(anchorEl);
    var handleClick = function handleClick(event) {
      setAnchorEl(event.currentTarget);
      onClick();
    };
    var handleClose = function handleClose() {
      setAnchorEl(null);
      onClose();
    };
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      onClick: handleClick
    }, props)), /*#__PURE__*/_react["default"].createElement(_core.Menu, {
      anchorEl: anchorEl,
      open: open,
      MenuListProps: {
        disablePadding: true
      },
      PaperProps: {
        style: {
          borderRadius: '10px'
        }
      },
      anchorOrigin: anchorOrigin,
      onClose: handleClose,
      getContentAnchorEl: null
    }, children));
  };
  return ContextMenu;
};
var _default = exports["default"] = withContextMenu;